module.exports = __webpack_public_path__ + "media/packs/images/flags/TG-c3a1aeba4a65af726e3faa9fd8522dec.svg";